module.exports = "<section class=\"sidebar-footer\">\r\n    <section class=\"app-footer\">\r\n        <div class=\"container-fluid\">\r\n          <span class=\"float-left\">\r\n            <span></span>\r\n          </span>\r\n          <span class=\"float-right\">\r\n            <span>{{this.AppConfig}}</span>\r\n          </span>\r\n        </div>\r\n      </section>\r\n  </section>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/layout/footer/footer.component.html
// module id = 1021
// module chunks = 1